export default [
  {
    path: '/aicrm',
    name: 'aicrm',
    component: () => import('@/pages/aicrm/Landing.vue'),
    meta: {
      title: 'AI 장사비서',
      layout: 'EmptyLayout',
      requireSignin: false,
      skipContract: true,
      isPublic: true
    }
  },
  {
    path: '/aicrm/main',
    name: 'aicrm-main',
    component: () => import('@/pages/aicrm/AiCrmMain.vue'),
    meta: {
      title: 'AI 장사비서 대시보드',
      layout: 'DefaultLayout',
      requireSignin: false,
      skipContract: true
    }
  }
]